import { useEffect, useState } from "react";
import { loadCatalog } from "@/lib/catalog";

export const CatalogGate = ({ children }) => {
  // O painel não usa os dados da loja (só funções puras de imagens), por isso não espera pelo catálogo: ganha-se o tempo do pedido.
  const [ready, setReady] = useState(() => window.location.pathname.startsWith("/admin"));
  useEffect(() => {
    let alive = true;
    loadCatalog().finally(() => {
      if (alive) setReady(true);
    });
    return () => {
      alive = false;
    };
  }, []);
  // Enquanto o catálogo chega (as páginas precisam dele para desenhar), mostra um fundo liso (igual ao do index.html), sem animação nem saltos.
  if (!ready) return <div className="bb-boot" data-testid="catalog-loading" aria-busy="true" />;
  return children;
};
